import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function VisionSection() {
  const features = ['Professional trained drivers', 'Clean wheelchair-accessible vehicles', 'Punctual pickup & drop-off', 'Compassionate patient-centered service'];
  return <section className="bg-[#F5F5F5] py-20" data-id="element-302">
      <div className="max-w-7xl mx-auto px-4" data-id="element-303">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-304">
          {/* Left - Image */}
          <div className="order-2 lg:order-1" data-id="element-305">
            <img src="https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=800&q=80" alt="Professional medical transport driver" className="rounded-lg shadow-xl w-full h-[400px] object-cover" data-id="element-306" />
          </div>

          {/* Right - Content */}
          <div className="order-1 lg:order-2" data-id="element-307">
            <h2 className="text-3xl lg:text-4xl font-bold text-[#0B1F3A] mb-6" data-id="element-308">
              Reliable Rides for Health, Comfort, and Care
            </h2>
            <p className="text-gray-700 text-lg mb-8" data-id="element-309">
              At Judah Medical Transport Company, we provide professional
              medical transportation services in Upper Marlboro, Maryland,
              designed to give you peace of mind. Our team prioritizes safety,
              punctuality, and dignity for every patient.
            </p>
            <ul className="space-y-4" data-id="element-310">
              {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-311">
                  <CheckCircleIcon className="h-6 w-6 text-[#E63946] mr-3 flex-shrink-0 mt-1" data-id="element-312" />
                  <span className="text-gray-700 text-lg" data-id="element-313">{feature}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}